<template>
  <sa-page-layout :btnSaveVisible="btnSaveVisible" :btnPrintVisible="true" :btnBackVisible="true" :pathResource="pathResource" :showModalLoading="showModalLoading" :data="jsonData" :linkback="linkback" :linkPrintData="linkPrintData" class="sa-no-space">
    <template slot="toolbar-title">
      <adi-anagrafica-component :id="idPropostaAccesso"></adi-anagrafica-component>
    </template>
    <template slot="table-body">
      <adi-pai-prestazioni-residenziali-semi-residenziali-edit-component :jsonData="jsonData" @showmodalloading="onShowModalLoading" @update="onUpdateJsonData" :utente="utente"></adi-pai-prestazioni-residenziali-semi-residenziali-edit-component>
    </template>
  </sa-page-layout>
</template>
<script>
// import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import AdiAnagraficaComponent from "../components/AdiAnagraficaComponent.vue";
import AdiPaiPrestazioniResidenzialiSemiResidenzialiEditComponent from "../components/AdiPaiPrestazioniResidenzialiSemiResidenzialiEditComponent.vue";
export default {
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  mixins: [UtilityMixin],
  components: { SaPageLayout, AdiPaiPrestazioniResidenzialiSemiResidenzialiEditComponent, AdiAnagraficaComponent },
  data() {
    return {
      pathResource: "/adipaiprestazioniresidenzialisemiresidenziali",
      linkback: "",
      linkNotBack: null,
      linkPrintData: null,
      showModalLoading: false,
      backAfterSave: false,
      id: "-1",
      index: 0,
      pathResourceStampa: null,
      key: 0,
      btnSaveVisible: false,
      idPropostaAccesso: "",
      jsonData: {
        assistenzaProgrammata: "",
        tipologiaRapportoDurata: "",
        eventualiSegnalazioniRelativePianoEsecutivo: "",
        listaObiettiviUtente: [{ descrizione: "", personaObiettivo: "UTENTE" }],
        listaObiettiviFamiglia: [{ descrizione: "", personaObiettivo: "FAMIGLIA" }],
        listaPaiUvi: [{ titolo: "", nomeCognome: "" }],
        dataOra: null,
        familiareUtente: "",
        idPropostaAccesso: "",
      },
    };
  },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
    let fonte = this.$route.query.fonte;
    me.idPropostaAccesso = this.$route.query.idPropostaAccesso;
    let path = this.$route.path.replace(/\/edit\/.*/, "");
    me.linkNotBack = path + "{editid}?";
    me.linkPrintData = me.pathResource + "/print/" + me.id;
    me.linkback = "/adipazienti/richieste/scheda/edit/" + me.idPropostaAccesso + "?fonte=" + fonte;
    me.loadPermessi();
    // console.log(me.utente);
  },
  methods: {
    onShowModalLoading(value) {
      let me = this;
      me.showModalLoading = value;
    },
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
    },
    loadPermessi() {
      let me = this;
      me.btnSaveVisible = UtilityMixin.methods.verificaPermessi(me.utente, "adipaiprestazioniresidenzialisemiresidenziali", 2) || UtilityMixin.methods.verificaPermessi(me.utente, "adipaiprestazioniresidenzialisemiresidenziali", 4);
    },
  },
};
</script>
